import { TBannerItem } from "../../../services/banner";

/** 按照1200 * 最大高度图片比例获取高度 */
export const getMaxHeight = (banners: TBannerItem[]): number => {
	let maxBanner = banners[0];
	banners.forEach((ele) => {
		if (+(ele?.height || "") > +(maxBanner?.height || "")) {
			maxBanner = ele;
		}
	});
	return (1200 * +(maxBanner.height || "")) / +(maxBanner?.width || "");
};

// 每张webCarouselWidth按照1200来算出高度
export const webCarouselWidth = 1200;
